import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { Observable } from 'rxjs';
import { ChargingPowerProfile } from '@models/chargingPowerProfile';


@Injectable({
  providedIn: 'root'
})
export class ChargingPowerProfilesService extends EntityService {

  public entityRoute = "chargingPowerProfiles";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getAll(): Observable<ChargingPowerProfile[]> {
    return this.http.get<ChargingPowerProfile[]>(this.baseUrl + 'api/chargingPowerProfiles');
  }
}
